'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var Icons = require('./Icons-46f5553f.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".CircleIcon_module_visuallyHidden__7712f543 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.CircleIcon_module_youtubeVideo__7712f543 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.CircleIcon_module_CardIcon__7712f543 {\n  background-color: #5e5e60;\n  width: 42px;\n  height: 42px;\n  border-radius: 48px;\n  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n  display: block;\n}\n.CircleIcon_module_CardIcon__7712f543 svg {\n  margin: 8px 8px 2px 9px;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Molecules/CircleIcon/CircleIcon.module.scss");
var modules_6d77a973 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"CircleIcon_module_visuallyHidden__7712f543","youtubeVideo":"CircleIcon_module_youtubeVideo__7712f543","CardIcon":"CircleIcon_module_CardIcon__7712f543"};

function CircleIcon(_ref) {
  var extraClass = _ref.extraClass,
    bgColor = _ref.bgColor,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    iconHSize = _ref.iconHSize,
    iconWSize = _ref.iconWSize,
    circleHeight = _ref.circleHeight,
    circleWidth = _ref.circleWidth;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_6d77a973.CardIcon, extraClass].join(' '),
    style: {
      backgroundColor: bgColor,
      height: circleHeight,
      width: circleWidth
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    iconColor: iconColor,
    iconHSize: iconHSize || 24,
    iconName: iconName,
    iconWSize: iconWSize || 24
  })));
}
CircleIcon.propTypes = {
  extraClass: index.propTypes.exports.string,
  bgColor: index.propTypes.exports.string,
  iconName: index.propTypes.exports.string,
  iconColor: index.propTypes.exports.string,
  iconHSize: index.propTypes.exports.number,
  iconWSize: index.propTypes.exports.number,
  circleHeight: index.propTypes.exports.number,
  circleWidth: index.propTypes.exports.number
};

exports.CircleIcon = CircleIcon;
